/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesProject_ProjectJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Project Job Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, June 27, 2019 - 12:00:28 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      06/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const Project_ProjectJobList = Loadable({
    loader: () => import('../containers/Project_ProjectJobs/Project_ProjectJobListContainer'),
    loading: Loading,
});

export const Project_ProjectJobForm = Loadable({
    loader: () => import('../containers/Project_ProjectJobs/Project_ProjectJobEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesProject_ProjectJobs.js